var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckboxTick = function SvgCheckboxTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "#036",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.544 15.287 20.844 3 24 5.916 7.672 21l-.18-.167-.128.118L0 14.148l3.156-2.916z"
  })));
};
export { SvgCheckboxTick as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSIjMDAzMzY2Ij4KICAgIDxwb2x5Z29uIHBvaW50cz0iNy41NDQgMTUuMjg3IDIwLjg0NCAzIDI0IDUuOTE2IDcuNjcyIDIxIDcuNDkyIDIwLjgzMyA3LjM2NCAyMC45NTEgMCAxNC4xNDggMy4xNTYgMTEuMjMyIj48L3BvbHlnb24+Cjwvc3ZnPgo=";